import { render } from "./WhatHappening.vue?vue&type=template&id=754b3a60"
import script from "./WhatHappening.vue?vue&type=script&lang=js"
export * from "./WhatHappening.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__